module.exports = __webpack_public_path__ + "img/arrow_filter_search_bar.2782231c.svg";